<!-- このコンポーネントのスタイルは _date-picker.scss で管理 -->
<form [formGroup]="formAgree">
  <mat-form-field floatLabel="always" class="form-field">
    <mat-label>{{label}}</mat-label>
    <input matInput
      [matDatepicker]="picker"
      placeholder="年/月/日"
      maxlength="10"
      class="browser-default"
      [(ngModel)]="dateOfBirth"
      (dateChange)="onDateChange($event)"
      formControlName="date_of_birth"
      [min]="dateOfBirthMin"
      [max]="dateOfBirthMax"
      >
    @if (dateOfBirth) {
      <button type="button" class="date-picker-clear" aria-label="Clear" (click)="dateOfBirth=''">×</button>
    }
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</form>
